<template>
    <van-collapse v-model="subActivate"  :accordion="true" >
        <van-collapse-item title="上家信息">
            <van-cell-group >
                <van-cell title="上家单位名称:"  :value="formData.unitName" />
                <van-cell title="上家性质:"  :value="formData.upperNature" />
                <van-cell title="上家地址:" :value="formData.contactAddress" />
                <van-cell title="联系人姓名:" :value="formData.contactName" />
                <van-cell title="联系方式:" :value="formData.contractPhone" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="欠款信息">
            <van-cell-group >
                <van-cell title="全部借款人姓名:"  :value="formData.customerName" />
                <van-cell title="抵押物是否与我司借款申请一致:"  :value="formData.mortgageSame" />
                <van-cell title="上家是否公证:" :value="formData.notarization"  />
                <van-cell title="抵押物情况:" :value="formData.mortgageInfo" />
                <van-cell title="存在关联贷款:" :value="formData.relationLoan" />
                <van-cell title="请输入该笔贷款为:" :value="formData.loanRemark" v-if="relationLoanShow" />
                <van-cell title="本金欠款(元):" :value="formData.principalArrears" />
                <van-cell title="利息欠款(元):" :value="formData.interestArrears" />
                <van-cell title="是否逾期:" :value="formData.overdue" />
                <van-cell title="逾期类型:" :value="formData.overdueType" />
                <van-cell title="逾期金额(元):" :value="formData.overdueAmount" v-if="overDueShow" />
                <van-cell title="逾期是否产生罚息:" :value="formData.penalty" v-if="overDueShow"/>
                <van-cell title="逾期是否上征信:" :value="formData.credit" v-if="overDueShow"/>
                <van-cell title="罚息欠款（含提还违约金）(元):" :value="formData.penaltyAmount"/>
                <van-cell title="上家总欠款(元):" :value="formData.upperTotalArrears" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="交接信息">
            <van-cell-group >
                <van-cell title="上家到期日期:"  :value="formData.upperDueDate" />
                <van-cell title="上家是否收押房本:"  :value="formData.collectProperty" />
                <van-cell title="房本所在:" :value="formData.propertyLocation" v-if="collectPropertyShow" />
                <van-cell title="还款当天能否拿房本:" :value="formData.propertyObtain" />
                <van-cell title="具体拿到房本的时间节点:" :value="formData.propertyObtainDate" />
                <van-cell title="能否提前还款:" :value="formData.prepay"  />
                <van-cell title="提前还款方式:" :value="formData.prepayMode" />
                <van-cell title="预约还款日期:" :value="formData.orderRepayDate" />
                <van-cell title="还款方式:" :value="formData.repayMode" />
            </van-cell-group>
        </van-collapse-item>

        <van-collapse-item title="出借账户信息" v-if="repayModeShow">
            <van-cell-group >
                <van-cell title="出借人户名:"  :value="formData.bankName" />
                <van-cell title="账号:"  :value="formData.bankAccount" />
                <van-cell title="开户行:" :value="formData.accountBank"  />
                <van-cell title="本次垫资的上家还款账户:" :value="formData.repayAccountSame" />
                <van-cell title="不一致的原因表述:" :value="formData.bankDifRemark" v-if="repayAccountSameShow"/>
                <van-cell title="上家还款账户户名:" :value="formData.repayBankName"  v-if="repayAccountSameShow"/>
                <van-cell title="上家还款账户开户支行:" :value="formData.repayAccountBank" />
            </van-cell-group>
        </van-collapse-item>

        <van-collapse-item title="借款账户信息" >
            <van-cell-group >
                <van-cell title="借款卡户名:"  :value="formData.customerAccountName" />
                <van-cell title="借款账号:"  :value="formData.customerBankAccount" />
                <van-cell title="开户支行:" :value="formData.customerBankName"  />
                <van-cell title="解押材料领取方式:" :value="formData.receiveMode" />
                <van-cell title="解押材料预计领取日期:" :value="formData.receiveDate" />
                <van-cell title="解押方式:" :value="formData.unzipMode"  />
                <van-cell title="上家配合度:" :value="formData.cooperationDegree" />
                <van-cell title="信息来源核对:" :value="formData.sourceCheck" />
                <van-cell title="补充说明:" :value="formData.handoverDegree" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item :title="title">
            <!--<FilesUpload style="margin-top: 10px;" :applyId="applyId" :groupCode="groupCode" :refName="bankType" ></FilesUpload>-->
            <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="groupCode" :refName="bankType" ></oss-upload>
        </van-collapse-item>
    </van-collapse>
</template>

<script>
import {findUpperBank} from '@/api/foreclosure'
import FilesUpload from '../../business/mortgage/files-upload'
import ossUpload from '@/views/component/oss-upload'
import Vue from 'vue'
import { debounce,cloneDeep } from 'lodash'
export default {
    name: 'upper_bank_info',
    components: {
        FilesUpload,
        ossUpload
    },
    props: {
        applyId: {
            type: String,
            default: ''
        },
        bankType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            formData:{},
            subActivate: [],
            relationLoanShow:false,
            overDueShow:false,
            collectPropertyShow:false,
            repayModeShow:false,
            repayAccountSameShow:false,
            title:'上家一押影像资料',
            groupCode:900
        }
    },
    mounted() {
        this.loadData()
        const titleMap = {
            'one': '上家一押影像资料',
            'second': '上家二押影像资料'
        }
        const groupCodeMap={
            'one': 900,
            'second': 901
        }
        this.title=titleMap[this.bankType]
        this.groupCode=groupCodeMap[this.bankType]
    },
    methods: {
        //日期格式化
        formatDate(date) {
            var ft=Vue.filter('dateYmdFormat')
            return ft(date)
        },
        loadData(){
            let self=this
            findUpperBank({applyId:self.applyId}).then(res => {
                if(res.success){
                    let upperBank=res.data.filter(bank=>bank.type==self.bankType)[0]||{}
                    let formData=cloneDeep(upperBank)
                    //日期处理
                    formData.upperDueDate!=null?(formData.upperDueDate = this.formatDate(formData.upperDueDate)):''
                    formData.orderRepayDate!=null?(formData.orderRepayDate = this.formatDate(formData.orderRepayDate)):''
                    formData.receiveDate!=null?(formData.receiveDate = this.formatDate(formData.receiveDate)):''
                    formData.operateDate!=null?(formData.operateDate = this.formatDate(formData.operateDate)):''
                    //显示字段处理
                    self.overDueShow=(formData.overdue=='是')
                    self.relationLoanShow=(formData.relationLoan=='是')
                    self.repayModeShow=(formData.repayMode=='线下还款')
                    self.collectPropertyShow=(formData.collectProperty=='否')
                    self.repayAccountSameShow=(formData.repayAccountSame=='与上家出借账户信息不一致')
                    //数值处理
                    formData.principalArrears=formData.principalArrears!=null?(formData.interestArrears.toString()):''
                    formData.interestArrears=formData.interestArrears!=null?(formData.interestArrears.toString()):''
                    formData.overdueAmount=formData.overdueAmount!=null?(formData.overdueAmount.toString()):''
                    formData.penaltyAmount=formData.penaltyAmount!=null?(formData.penaltyAmount.toString()):''
                    formData.upperTotalArrears=formData.upperTotalArrears!=null?(formData.upperTotalArrears.toString()):''
                    debounce(() => {
                        this.formData=formData
                    }, 1000)()
                }
            })
        }

    }
}
</script>

<style scoped>

</style>
